// Arrastrar una hoja inferior para cerrarla, como en las apps nativas. Funciones puras; las usa
// useSheetMotion.

// Lo que hay que mover el dedo (px) para que cuente como arrastre y no como toque.
export const DRAG_SLOP = 6
// Hacia arriba la hoja apenas se mueve (ya está abierta del todo): resistencia y un tope.
const UP_RESISTANCE = 4
const UP_LIMIT = 24
// Se cierra si se baja más de esta parte de su altura (o de DISMISS_MAX px), o si se suelta
// deprisa hacia abajo (px/ms) tras moverla un poco.
const DISMISS_FRACTION = 0.25
const DISMISS_MAX = 160
const FLING_VELOCITY = 0.5
const FLING_MIN = 24

// Cuánto se desplaza la hoja para un movimiento del dedo `dy` (positivo, hacia abajo).
export const dragOffset = (dy: number): number => {
	if (!Number.isFinite(dy)) return 0
	return dy >= 0 ? dy : Math.max(-UP_LIMIT, dy / UP_RESISTANCE)
}

export type DragSample = { y: number; t: number }

// Velocidad al soltar (px/ms, positiva hacia abajo), con la primera y la última muestra. Sin
// tiempo entre ellas (o con menos de dos), 0.
export const releaseVelocity = (samples: readonly DragSample[]): number => {
	const first = samples[0]
	const last = samples[samples.length - 1]
	if (!first || !last || last.t <= first.t) return 0
	return (last.y - first.y) / (last.t - first.t)
}

// Si soltar la hoja con ese desplazamiento y esa velocidad la cierra o la devuelve a su sitio.
export const shouldDismiss = (offset: number, velocity: number, height: number): boolean => {
	if (offset <= 0) return false
	if (velocity >= FLING_VELOCITY && offset >= FLING_MIN) return true
	const threshold = height > 0 ? Math.min(height * DISMISS_FRACTION, DISMISS_MAX) : DISMISS_MAX
	return offset >= threshold
}
